import React from "react";
import { CellContext } from "@tanstack/react-table";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";
import { getRatingColor } from "@/lib/utils";

export const RatingCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue()
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (status: string) => {
        setValue(status);
        table.options.meta?.updateData(index, id, status)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    let style = getRatingColor(value as "High" | "Medium" | "Low");

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button className={`w-full ${style} text-white border-none focus:ring-0 rounded-none`}>
                        {value as string}
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="center" className="p-0 rounded-none">
                    <DropdownMenuItem
                        key={id + "_rating_low"}
                        className="bg-chart-green rounded-none"
                        onClick={() => {
                            onBlur("Low");
                        }}
                    >
                        <div className="w-full text-center">Low</div>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        key={id + "_rating_medium"}
                        className="bg-chart-amber rounded-none"
                        onClick={() => {
                            onBlur("Medium");
                        }}
                    >
                        <div className="w-full text-center">Medium</div>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        key={id + "_rating_high"}
                        className="bg-chart-red text-white rounded-none"
                        onClick={() => {
                            onBlur("High");
                        }}
                    >
                        <div className="w-full text-center">High</div>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        );
    }
    return <div className={"text-center text-white " + style}>{value as string}</div>
};